export const NON_NULLABLE = <T>(e: T): e is NonNullable<T> => e != undefined;
